module.exports = __webpack_public_path__ + "static/media/icon_billing_black.121cb0ed.svg";